import React, { useState } from "react";
import serviceProvider from '../../services/axios'
import Moment from "react-moment";
import { Link } from "react-router-dom";
export const NotificationView = (props) => {
	const [rate, setRate] = useState(1);
	const notificationDataItems = props.notificationData;
	if (!notificationDataItems.length) {
		return null;
	}
	
	const notificationDataItem = props.notificationData[0];
	const notificationData = notificationDataItem.notifications;
	const uid = notificationDataItem.uid;
	const markAllRead = () => {
		setRate(rate + 1);
		serviceProvider.post("/notification?type=markAllRead", JSON.stringify({ uid: uid }), true).then((response) => {
			props.onRefresh(rate);
		});
	};
	const clearAll = () => {
		setRate(rate + 1);
		serviceProvider.post("/notification?type=clearAll", JSON.stringify({ uid: uid }),true).then((response) => {
			props.onRefresh(rate);
		});
		
	};
	const markUnread = (nid) => {
		setRate(rate + 1);
		console.log(nid);
		serviceProvider.post("/notification?type=unread", JSON.stringify({ uid: uid, nid: nid }), true).then((response) => {
			props.onRefresh(rate);
		});
	};
	const markRead = (nid) => {
		setRate(rate + 1);
		serviceProvider.post("/notification?type=read", JSON.stringify({ uid: uid, nid: nid }),true).then((response) => {
			props.onRefresh(rate);
		});
	};
	const clearOne = (nid) => {
		setRate(rate + 1);
		serviceProvider.post("/notification?type=clearOne", JSON.stringify({ uid: uid, nid: nid }),true).then((response) => {
			props.onRefresh(rate);
		});
	};
	let unread=0;
	if (notificationData.length) {
		const notificationList = notificationData.map((data, index) => {
			
			unread = data.is_read == 0 ? unread+1 : unread;
			return (
				
				<li key={data.id} className={data.is_read == 0 ? "not_li" : "not_li active_read"}>
					<div className="lft-wrap">
						<p>
							{/* <span>Judit Bernat</span> mentioned you in a comment on
							<span>Assessment: Operational Excellence section</span> */}
							<div onClick={() => markRead(data.id)} className="refreshReply" dangerouslySetInnerHTML={{ __html: data.description }}></div>
							
						</p>
						<span>
							<Moment fromNow ago>
								{data.date}
							</Moment>
						</span>
					</div>
					<div className="operate-icon">
						<span onClick={() => clearOne(data.id)} className="clear-notification">
							<img src={require("../../assets/img/top-header/cross.svg").default} alt="" className="cross-mark" />
							<div className="clear_notf_ttip">Clear notification</div>
						</span>
						{data.is_read == 0 ? (
							<span onClick={() => markRead(data.id)} className="mark-read">
								<div className="mark_unread_ttip">Mark as read</div>
							</span>
						) : (
						    //setUnread(1);
							<span onClick={() => markUnread(data.id)} className="mark-read">
								<div className="mark_unread_ttip">Mark as unread</div>
							</span>
						)}
					</div>
				</li>
			);
		});
		
		
		return (
			<>
				<div className="upgrd-not-head">
					<span className="notification-ttl">Notifications</span>
					{unread>0 && 
					<button onClick={markAllRead} className="mark-ttl">
						Mark all as read
					</button>
					}
					<button onClick={clearAll} className="clear-ttl">
						Clear All
					</button>
					<button  className="close-btn s-10-2021" onClick={props.HandleNotificationPopup}>
							<img src={require("../../assets/img/top-header/cross.svg").default} alt=""/>
					</button>
				</div>
				<div className="upgrd-not-list">
					<ul>{notificationList}</ul>
				</div>
			</>
		);
	} else {
		return (
			<>
				<div className="upgrd-not-head">
					<span className="notification-ttl">Notifications</span>
					<button  className="close-btn s-10-2021" onClick={props.HandleNotificationPopup}>
							<img src={require("../../assets/img/top-header/cross.svg").default} alt=""/>
					</button>
				</div>
				<div className="upgrd-not-list">
					<div className="zero_notification">
						<img src={require("../../assets/img/top-header/no_notification.svg").default} alt="" className="no_notification" />
						<h4>No notifications right now</h4>
						<p>
							When there's an activity on the platform, <br></br> we'll show the notifications here.
						</p>
					</div>
				</div>
			</>
		);
	}
};
